import { render } from "./id_liveness_verification.html?vue&type=template&id=210f06f8&scoped=true&external"
import script from "./id_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./id_liveness_verification.js?vue&type=script&lang=js&external"

import "./IdVerificationReport.vue?vue&type=style&index=0&id=210f06f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210f06f8"]])

export default __exports__